import { render } from 'react-dom';
import StatusBarError from '../components/StatusBar/StatusBarError';
import Constants from '../components/StatusBar/Constants';
import Translations from '../utils/Translations';
import { setCookie, getCookie } from '../utils/CommonUtils';
import Flux from '../flux/Flux';

function run(containerId) {
	const container = document.getElementById(containerId);

	setCookie(Flux.Constants.CookieNames.COOKIES_BLOCKED, 'cookiesBlocked', 1, '/', '', true, Flux.Constants.CookieSameSiteAttributes.LAX);
	const myCookie = getCookie(Flux.Constants.CookieNames.COOKIES_BLOCKED);

	if (!myCookie && container) {
		render(
			<StatusBarError msgIntro={Translations.get('StatusBarCookiesBlocked')} barColor={Constants.BARCOLOR_RED} isVisible={true} />,
			container,
		);
	}
}

export { run };
